import { Wordmark } from './nav';
import { BackIcon } from './icons';

/**
 * Phone chrome. Replaces `ion-header`/`ion-toolbar`, which rendered a 56px
 * centred-logo bar at every viewport width — including 2560px.
 *
 * Not rendered above `lg`: on desktop the rail carries the wordmark and the
 * page carries its own header, so a second bar would only steal vertical room.
 */
export const TopBar: React.FC<{
  title?: string;
  onBack?: () => void;
  /** Makes the wordmark a way back to the start page, as the rail's is. */
  onHome?: () => void;
  right?: React.ReactNode;
  className?: string;
}> = ({ title, onBack, onHome, right, className = '' }) => (
  <header
    data-testid="top-bar"
    className={`sticky top-0 z-20 flex h-14 shrink-0 items-center gap-3 border-b border-divider bg-card px-4 pt-[env(safe-area-inset-top)] ${className}`}
  >
    {onBack && (
      <button
        type="button"
        onClick={onBack}
        aria-label="Back"
        data-testid="top-bar-back"
        className="-ml-2 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-foreground-soft hover:bg-shell"
      >
        <BackIcon size={20} />
      </button>
    )}
    {onHome ? (
      <button
        type="button"
        onClick={onHome}
        aria-label="Start page"
        data-testid="top-bar-home"
        className="-mx-1 shrink-0 rounded-md px-1 py-2 hover:bg-shell"
      >
        <Wordmark className="text-[11px]" />
      </button>
    ) : (
      !onBack && <Wordmark className="text-[11px]" />
    )}
    {title && (
      <div className="min-w-0 flex-1 truncate text-sm font-semibold">{title}</div>
    )}
    <div className="ml-auto flex items-center gap-2">{right}</div>
  </header>
);
